export const mapSortColumnToRequestData = (columnId: string): string => {
  switch (columnId) {
    case 'advertiser':
      return 'ADVERTISER';
    case 'brand':
      return 'BRAND';
    case 'dspName':
      return 'DSP';
    case 'externalId':
      return 'EXTERNAL_ID';
    case 'formatName':
      return 'PRODUCT_FORMAT';
    case 'productCategory':
      return 'PRODUCT_CATEGORY';
    case 'size':
      return 'WIDTH';
    case 'type':
      return 'TYPE';
    case 'updated':
      return 'UPDATED_AT';
    case 'duration':
      return 'DURATION';
    case 'externalAgencyId':
      return 'EXTERNAL_AGENCY';
    case 'clickThroughUrl':
      return 'CLICK_THROUGH_URL';
    case 'externalAdvertiserName':
      return 'EXTERNAL_ADVERTISER_NAME';
    default:
      return 'UPDATED_AT';
  }
};

export const parsePageIndex = (param: string | null): number => {
  const parsed = Number(param);
  if (!Number.isFinite(parsed) || parsed < 1) return 0;
  return parsed - 1;
};

export const normalizePageIndex = (pageIndex: number): number => {
  return pageIndex + 1;
};
